export default __webpack_public_path__ + "static/media/alphabet-yellow-u.cd329a8a.png";